/**
 * Authorization Roles (role-based)
 * state.auth.user.role = ['admin' | 'expert' | 'operator']
 *
 * Final rules:
 * - expert: sees everything EXCEPT users block
 * - operator: sees operator + notifications only
 * - admin: sees users block only
 */
const authRoles = {
	// --- Block-level sets ---
	operatorBlock: ['operator', 'expert'],
	expertBlock: ['expert'],
	techBlock: ['expert'],
	notificationsBlock: ['operator', 'expert'],
	usersBlock: ['admin'],

	// --- Operator items (operator + expert) ---
	whatif: ['operator', 'expert'],
	unitOptimizerOverview: ['operator', 'expert'],
	optimizationPipeline: ['operator', 'expert'],
	optimizationPipelineV2: ['operator', 'expert'],

	// --- Expert items (expert only) ---
	optimizationCase: ['expert'],
	optimizer: ['expert'],
	optimizerLog: ['expert'],
	dataset: ['expert'],
	aspect: ['expert'],
	whatifExpert: ['expert'],
	whatifGroup: ['expert'],
	fittingCase: ['expert'],
	taskManager: ['expert', 'operator'],
	fitterLog: ['expert'],
	transformer: ['expert'],
	measurement: ['expert'],
	scheduler: ['expert'],

	optimizationPipelineLog: ['expert'],
	simulationMonitor: ['expert'],
	simulationMonitorLog: ['expert'],
	edtDynamicCheck: ['expert'],
	edtDynamicCheckLog: ['expert'],
	piWriter: ['expert'],
	piWriterLog: ['expert'],
	opcDaWriter: ['expert'],
	opcDaWriterLog: ['expert'],
	unitOptimizer: ['expert'],
	unitOptimizerLog: ['expert'],
	modelValidation: ['expert'],
	modelValidationLog: ['expert'],
	outlierDetector: ['expert'],

	// --- Tech items (expert only) ---
	model: ['expert'],
	driver: ['expert'],
	driverLog: ['expert'],
	piMeasurementReader: ['expert'],
	labConnection: ['expert'],
	labMeasurementReader: ['expert'],
	measurementUnit: ['expert'],
	pictogram: ['expert'],

	// --- Notifications (operator + expert) ---
	notifications: ['operator', 'expert'],

	// --- Users (admin only) ---
	userAccount: ['admin'],
	userRole: ['admin'],
	userGroup: ['admin'],

	onlyGuest: []
};

export default authRoles;
